import clientConfigApi from '../config/config'
import axios from 'axios';
import { INROOMTAB, WITH_MASTER_CONNECTOR, token } from '../config/constant';
import { data } from 'jquery';
import { wipeGuestData } from '../JS/wipeGuestData';
import { getCurrentGuestDetails } from '../layout2.0/JS/utility';
import smooch from 'smooch';
import { setGuesLogin } from './action';

function callApi(path, sessionToken) {
  console.log("path, sessionToken", path, sessionToken);
  try {
    let data = clientConfigApi.post(
      path,
      {
        "payload": {},
        "header": {
          "sessionToken": sessionToken //? sessionToken : token,
        },
      }
    )
      .catch(
        ({ response = {} }) => {
          console.log("Api failed with the status code:", response.status);
        }
      )
    //console.log("data",data)
    return data
  } catch (e) {
    console.log(`error in api call to path=${path}`, e);
  }
}

export const guestLanguage = (sessionToken) => {
  // console.log("guestLanguage", sessionToken);
  let guestLang = "";
  let guestLanguage = {};
  return async dispatch => {
    try {
      let sessionData = sessionStorage.getItem("guestLanguage");
      //console.log("sessionData",sessionData)
      if (!sessionData || sessionData === "undefined") {
        if (process.env.REACT_APP_HARDCODE_LANGUAGE_APIS == "true") {
          console.log("guestPreferredLanguage using default language");
  
          guestLanguage = {
            data: {
              payload: {
                preferredLanguageCode: "en"
              },
            }
          }
        } else {
          guestLanguage = await callApi("/guestPreferredLanguage/fetch", sessionToken);
        }
        //console.log("guestLanguage", guestLanguage)
        sessionData = JSON.stringify(guestLanguage);
        sessionStorage.setItem("guestLanguage", sessionData);
        if (guestLanguage && guestLanguage.data && guestLanguage.data.payload) {          
          dispatch({
            type: 'Guest_Language',
            payload: guestLanguage.data.payload
          })
        }
      } else {
        if (sessionData === "undefined") {
          sessionData = null
        } else {
          sessionData = JSON.parse(sessionData);
        }
        //console.log("sessionData", sessionData);
        if (sessionData && sessionData.data && sessionData.data.payload) {
          guestLang = sessionData.data.payload
          //console.log("guest preferred Lang", guestLang);
        }
        dispatch({
          type: 'Guest_Language',
          payload: guestLang
        })
      }
    } catch (e) {
      console.log("error in guest language api", e);
    }
  }
}

export const guestDetails = (sessionToken, wipeGuestData, guestToken, saveGuestRequest, setLoginRequied) => {
  return async dispatch => {
    let room = localStorage.getItem("room")
    room = room && room !== "null" ? room : "notLogin"

    let header;

    if (process.env.REACT_APP_INROOMTAB == "true" && localStorage.getItem("roomID") && localStorage.getItem("roomID") !== "null") {
      header = {
        "sessionToken": sessionToken
      }
    } else {
      if(!guestToken){return}
      header = {
        "sessionToken": sessionToken,
        "guestToken": guestToken
      }
    }

    try {
      clientConfigApi.post(
        "/guestDetails/fetch" + `?dId=${localStorage.getItem('deviceIdentifierFromCMS')}&rn=${room}`,
        {
          "payload": {},
          "header": header
        }
      ).then(async (res) => {
        console.log("guestDetails res", res);
        let guestDetail
        const resCallBackFun = (allGuest, resNo) => {
          if (!resNo || resNo === "null") {
            dispatch({
              type: 'Guest_Details',
              payload: {
                guestDetails: res.data.payload.guestDetails,
                reservationNo: null
              }
            });
            guestDetail = {
              guestDetails: res.data.payload.guestDetails,
              reservationNo: null
            }
          } else {
            dispatch({
              type: 'Guest_Details',
              payload: {
                guestDetails: res.data.payload.guestDetails,
                reservationNo: resNo
              }
            });
            guestDetail = {
              guestDetails: res.data.payload.guestDetails,
              reservationNo: resNo
            }
            let guestDetails = res.data.payload.guestDetails
            let gdprAnswers = localStorage.getItem("GDPR-Response")
            if (gdprAnswers && gdprAnswers !== "null") {
              console.log("sending GDPR answers", Object.values(JSON.parse(gdprAnswers)))
              saveGuestRequest(
                { ...guestDetails, reservationNumber: resNo, location: guestDetails.locationId },
                sessionToken,
                Object.values(JSON.parse(gdprAnswers)),
                "",
                (status) => status ? localStorage.removeItem("GDPR-Response") : "")
            }
          }
          localStorage.setItem("Guest_Details", JSON.stringify(guestDetail))
          localStorage.setItem("GuestListSetTimestamp", new Date())
          // if(localStorage.getItem("GuestIsCheckin") != "true"){
          //   setLoginRequied(false)
          //   window.location.reload()
          // }
          dispatch({
            type: 'Check_In_Guest_List',
            payload: allGuest
          })
        }
        if (res && res.data && res.data.payload) {
          //console.log("guest Details", guestDetails);
          guestReservation(resCallBackFun, res.data.payload.guestDetails, dispatch);
          dispatch({
            type: 'Guest_Details',
            payload: {
              guestDetails: res.data.payload.guestDetails,
              reservationNo: null
            }
          });
        }
        if (res && res.data && res.data.payload
          && res.data.payload.guestDetails && !res.data.payload.guestDetails.guestToken) {
          if (localStorage.getItem("GuestIsCheckin") == "true") {
            console.log("wipe data from guest details, due to guest token not found");
            wipeGuestData({ inRoomTab: process.env.REACT_APP_INROOMTAB == "true" });
          }
        }
        if (window.FirebasePlugin) {
          window.FirebasePlugin.logEvent("guest_details_api_response", { status: "success" });
        }
      })
        .catch(
          (response) => {
            console.log("Api failed with the status code:", response.status);
            if (window.FirebasePlugin) {
              window.FirebasePlugin.logError("guestDetails/fetch Api failed with the status code:" + response.message)
              window.FirebasePlugin.logEvent("guest_details_api_response", { status: "failed", error: response.message });
            }
          }
        )
      //guestDetails = await callApi("/guestDetails/fetch", sessionToken);
    }
    catch (e) {
      console.log('error in guest detail api call.', e);
      if (window.FirebasePlugin) {
        window.FirebasePlugin.logError("/guestDetails/fetch Api failed with the status code:" + e.message)
        window.FirebasePlugin.logEvent("guest_details_api_response", { status: "failed", error: e.message });
      }
    }
  }
}

const guestReservation = (resCallBackFun, guestInfo, dispatch) => {
  console.log("sessionToken, guestInfo", guestInfo);
  let room = localStorage.getItem("room")
  room = room && room !== "null" ? room : "notLogin"
  //  return async dispatch => {
  try {
    clientConfigApi.post(
      "/checkInGuestList/fetch" + `?dId=${localStorage.getItem('deviceIdentifierFromCMS')}&rn=${room}`,
      {
        "payload": {},
        "header": {
          "locationId": guestInfo.locationId,
          "guestToken": guestInfo.guestToken
        }
      }
    ).then(
      (res) => {
        console.log("res", res);
        if (res && res.data && res.data.payload) {
          localStorage.setItem("room", res.data.payload.locationName);
          dispatch({
            type: 'Set_User_Login',
            payload: true
          });
          if (res.data.payload.guestDetails.length > 1) {
            res.data.payload.guestDetails.forEach((iterator) => {
              if (iterator.guestToken == guestInfo.guestToken) {
                resCallBackFun(res.data.payload.guestDetails, iterator.reservationNumber);
              }
            })
          } else {
            resCallBackFun(res.data.payload.guestDetails,
              res.data.payload.guestDetails[0].reservationNumber);
          }
          let list = getCurrentGuestDetails(res.data.payload.guestDetails)
          // localStorage.setItem("Check_In_Guest_List",JSON.stringify(res.data.payload.guestDetails))
          // dispatch({
          //   type: 'Check_In_Guest_List',
          //   payload: res.data.payload.guestDetails
          // })

          // updated checkInGuestlist to only have loggedInGuest
          localStorage.setItem("Check_In_Guest_List", JSON.stringify(list))
          dispatch({
            type: 'Check_In_Guest_List',
            payload: list
          })
          localStorage.setItem("Set_Current_Logged_In_Guest_Details", JSON.stringify(list))
          localStorage.setItem("GuestIsCheckin", true)
          list[0] && list[0].customerId && localStorage.setItem("resReservationCustomerId", list[0].customerId)
          list[0] && list[0].clientId && localStorage.setItem("resReservationClientId", list[0].clientId);
          list[0] && list[0].clientId && localStorage.setItem("eventsReservationClientId", list[0].clientId);


          dispatch({
            type: 'Set_Current_Logged_In_Guest_Details',
            payload: list
          })
          if (window.FirebasePlugin) {
            window.FirebasePlugin.logEvent("checkin_guest_list_api_response", { status: "success" });
          }
        }
      }
    ).catch(({ response = {} }) => {
      if (response.status == 401) {
        wipeGuestData({ inRoomTab: process.env.REACT_APP_INROOMTAB == "true" })
      }
      // console.log("error in guestReservation api", e);
      resCallBackFun(null, null);
      if (window.FirebasePlugin) {
        window.FirebasePlugin.logError("/checkinGuestList/fetch Api failed with the status code:" + response.message)
        window.FirebasePlugin.logEvent("checkin_guest_list_api_response", { status: "failed", error: response.message });
      }
    })
  } catch (e) {
    console.log("error in guestReservation.")
    if (window.FirebasePlugin) {
      window.FirebasePlugin.logError("/checkinGuestList/fetch Api failed with the status code:" + e.message)
      window.FirebasePlugin.logEvent("checkin_guest_list_api_response", { status: "failed", error: e.message });
    }
  }
}

export const setCheckinGuestList = (guestList, guestDetails, list) => {
  return async dispatch => {
    dispatch({
      type: "Check_In_Guest_List",
      payload: guestList
    })
    dispatch({
      type: "Guest_Details",
      payload: guestDetails
    })
    dispatch({
      type: 'Set_Current_Logged_In_Guest_Details',
      payload: list
    })
  }
}

export const getHotelLanguages = (sessionToken, callback) => {
  return async dispatch => {
    let room = localStorage.getItem("room")
    room = room && room !== "null" ? room : "notLogin"

    const defaultLang = {
      languages: [
        {
          language: "English",
          languageCode: "en",
        }
      ],
      preferredLanguageCode: "en"
    };
    
    if(window.FirebasePlugin) window.FirebasePlugin.startTrace("get_Hotel_Languages");

    if (process.env.REACT_APP_HARDCODE_LANGUAGE_APIS == "true") {
      console.log("hotelLanguage using default language");
      
      dispatch({
        type: 'Hotel_language',
        payload: defaultLang
      });

      callback(true);
      return
    }

    try {
      await clientConfigApi.get(
        "/hotelLanguage/fetch-all" + `?dId=${localStorage.getItem('deviceIdentifierFromCMS')}&rn=${room}`
      )
        .then(
          (hotelLang) => {
            if (hotelLang && hotelLang.data && hotelLang.data.payload) {
              //console.log("hotelLanguages", hotelLang.data.payload);
              dispatch({
                type: 'Hotel_language',
                payload: hotelLang.data.payload
              })
              localStorage.setItem("Cached_Hotel_language", JSON.stringify(hotelLang.data.payload))
              callback(true)
            }
          }
        )
        .catch(
          ({ response = {} }) => {
            console.log("Api failed with the status code:", response.status)
            
            if(window.FirebasePlugin && response.message ) window.FirebasePlugin.incrementCounter("get_Hotel_Languages" , response.message ,()=>{console.log("success get_Hotel_Languages")}, ()=>{console.log("failure get_Hotel_Languages")});
            if(window.FirebasePlugin) window.FirebasePlugin.stopTrace("get_Hotel_Languages");
            if(window.FirebasePlugin && response.message ) window.FirebasePlugin.setCrashlyticsCustomKey('get_Hotel_Languages', response.message );
  
            if(window.FirebasePlugin) { window.FirebasePlugin.logError(
              "A non-fatal error",
              function () {
                  console.log("Sent non-fatal error");
              },
              function (error) {
                  console.error("Failed to send non-fatal error", error);
              }
          ); }

            const cachedHotelLang = localStorage.getItem("Cached_Hotel_language");
            if (cachedHotelLang) {
              dispatch({
                type: 'Hotel_language',
                payload: JSON.parse(cachedHotelLang)
              })
              callback(true)
            } else {
              dispatch({
                type: 'Hotel_language',
                payload: defaultLang
              });

              callback(true);
            }

            // callback(false);
          }
        )
    } catch (e) {
      console.log("error in hotel language api", e);
    }
  }
}

// action for getting current server time
export const getServerTime = (callback) => {
  let data = {}
  let room = localStorage.getItem("room")
  room = room && room !== "null" ? room : "notLogin"
 
  if(window.FirebasePlugin) window.FirebasePlugin.startTrace("server_time_api");

  return async dispatch => {
    try {
      data = await clientConfigApi.get(
        "/currentServerTimeDetails/fetch" + `?dId=${localStorage.getItem('deviceIdentifierFromCMS')}&rn=${room}`
      )
        .catch(
          (response) => {
            console.log("Api failed with the status code:", response)
            if(window.FirebasePlugin && response.message ) window.FirebasePlugin.incrementCounter("server_time_api" , response.message ,()=>{console.log("success server_time_api")}, ()=>{console.log("failure server_time_api")});
            if(window.FirebasePlugin) window.FirebasePlugin.stopTrace("server_time_api");
            if(window.FirebasePlugin && response.message ) window.FirebasePlugin.setCrashlyticsCustomKey('server_time_api', response.message );
  
            if(window.FirebasePlugin) { window.FirebasePlugin.logError(
              "A non-fatal error",
              function () {
                  console.log("Sent non-fatal error");
              },
              function (error) {
                  console.error("Failed to send non-fatal error", error);
              }
          ); }

            const cachedServerTime = localStorage.getItem("Cached_Server_Time");
            if (cachedServerTime) {
              dispatch({
                type: 'Get_Server_Time',
                payload: JSON.parse(cachedServerTime)
              })
              callback(true)
            } else {
             callback(false);
            }

            if (window.FirebasePlugin) {
              window.FirebasePlugin.logError("/currentServerTimeDetails/fetch Api failed with the status code:" + response.message)
              window.FirebasePlugin.logEvent("server_time_api_response", { status: "failed", error: response.message });
            }
          }
        )
      if (data && data.data && data.data.payload) {
        //console.log("server_time_api", data.data.payload);

        if(window.FirebasePlugin) window.FirebasePlugin.stopTrace("server_time_api");
        if(window.FirebasePlugin && data.data.payload ) window.FirebasePlugin.setCrashlyticsCustomKey('server_time_api', data.data.payload );

        if(window.FirebasePlugin) { window.FirebasePlugin.logError(
          "A non-fatal error",
          function () {
              console.log("Sent non-fatal error");
          },
          function (error) {
              console.error("Failed to send non-fatal error", error);
          }
      ); }
      

        dispatch({
          type: 'Get_Server_Time',
          payload: data.data.payload
        });
         localStorage.setItem("Cached_Server_Time", JSON.stringify(data.data.payload))

        if (window.FirebasePlugin) {
          window.FirebasePlugin.logEvent("server_time_api_response", { status: "success" });
        }
        callback(true, data.data.payload);
      }
    } catch (e) {
      console.log("error in fetch server time", e);
      if (window.FirebasePlugin) {
        window.FirebasePlugin.logError("/currentServerTimeDetails/fetch Api failed with the status code:" + e.message)
        window.FirebasePlugin.logEvent("server_time_api_response", { status: "failed", error: e.message });
      }
    }
  }
}

export const getRealtimeBookingUrl = (callback) => {
  console.log("RealtimeBookingUrl called");
  let room = localStorage.getItem("room");
  let sessionToken = localStorage.getItem('GuestJourneySessionToken');
  let userInfo = JSON.parse(localStorage.getItem("Guest_Details"));

  if (room && room !== "null") {
    try {
      clientConfigApi.get("/configsV2/fetch" + `?type=realTimeResURL&locationId=${userInfo.guestDetails.locationId}&reservationNumber=${userInfo.reservationNo}`,
        {
          headers: {
            Authorization: `Bearer ${sessionToken}`
          }
        })
        .then((res) => {
          console.log("realTimeResURL Response" + res.status + JSON.stringify(res));
          if (res.data.payload.realTimeResURL && res.data.payload.realTimeResURL !== "null") {
            callback(true, res.data.payload.realTimeResURL)
          } else {
            callback(false, "")
          }
        })
        .catch(
          (errResp) => {
            console.log("realTimeResURL api failed with the status code:", JSON.stringify(errResp.response.data.header.status.msg));
            callback(false, errResp.response.data.header.status.msg)
            if (window.FirebasePlugin) {
              window.FirebasePlugin.logError("realTimeResURL Api failed with the status code:" + errResp)
              window.FirebasePlugin.logEvent("realTimeResURL_api_response", { status: "failed", error: errResp.response.data.header.status.msg });
            }
          }
        )
    }
    catch (e) {
      callback(false, e.message)
      console.log('error in realTimeResURL api call.', e);
      if (window.FirebasePlugin) {
        window.FirebasePlugin.logError("realTimeResURL Api failed with the status code:" + e.message)
        window.FirebasePlugin.logEvent("guest_details_api_response", { status: "failed", error: e.message });
      }
    }
  }
}


export const fetchSissonToken = ({ encodedData, deviceID }, callBackFun, deviceName) => {

  let sessionToken = localStorage.getItem('GuestJourneySessionToken');
  let room = localStorage.getItem("room");
  let roomID = localStorage.getItem("roomID");
  let device_name = localStorage.getItem("deviceName")
  const FCMToken = localStorage.getItem("FCM_token");
  const deviceType = window.device ? window.device.platform : "Other";

  let master_hotel_code = (process.env.REACT_APP_CLIENT_CONFIG || "").replace("GJ_", "").toUpperCase();
  let current_hotel_code = (localStorage.getItem("clientId") || sessionStorage.getItem("clientId") || process.env.REACT_APP_CLIENT_CONFIG || "").replace("GJ_", "").toUpperCase();


  try {
    //console.log("webAppData", encodedData, "location", roomID, "roomId", room, "deviceName", deviceName);
    console.log('Register API');
    return async dispatch => {
      if (!sessionToken || sessionToken == "null" || sessionToken == "undefined") {
        clientConfigApi.post(
          "/guestDevice/register",
          {
            "header": {
              "deviceTokenIdentifier": FCMToken,
              "deviceType": deviceType
            },
            "payload": {
              "webAppData": encodedData,
              "key": "public-key",
              "location": roomID ? roomID : null,
              "roomId": room && room !== "null" ? room : null,
              "deviceName": device_name || deviceName
            }
          }
        ).then(({ data = {} }) => {
          if (data.payload && data.payload.deviceId && data.payload.deviceId === deviceID) {
            console.log('data from fetch api', data)
            localStorage.setItem('GuestJourneySessionToken', data.payload.sessionToken);
            localStorage.setItem('GuestJourneyHotelCode', current_hotel_code);
            localStorage.setItem('deviceIdentifierFromCMS', data.payload.identifier);
            console.log("device registertion api success", data.payload);

            if (WITH_MASTER_CONNECTOR) {
              if (master_hotel_code == current_hotel_code) {
                localStorage.setItem("GuestJourneyMasterConnectorSessionToken", data.payload.sessionToken)
              }
            }

            dispatch({
              type: 'Session_Token',
              payload: data.payload.sessionToken
            })
            callBackFun(data.payload.sessionToken, data.statusCode);
            if (window.FirebasePlugin) {
              window.FirebasePlugin.logEvent("register_api_response", { status: "success" });
            }
          }
        }
        ).catch((err) => {
          console.log("session token fetch api faild", err.response && err.response.status);
          if (window.FireBasePlugin) {
            window.FirebasePlugin.logError("/guestDevice/register Api failed with the status code:" + err.message)
            window.FirebasePlugin.logEvent("register_api_response", { status: "failed", error: err.message });
          }

          callBackFun(null, err.response && err.response.status);
        }
        )
      } else {
        //console.log("got session store from store", sessionToken);
        dispatch({
          type: 'Session_Token',
          payload: sessionToken
        })
      }
    }
  } catch (err) {
    console.log("session token fetch api faild", err.response.status);
    if (window.FirebasePlugin) {
      window.FirebasePlugin.logError("/guestDevice/register Api failed with the status code:" + err.message)
      window.FirebasePlugin.logEvent("register_api_response", { status: "failed", error: err.message });
    }
    callBackFun(null, err.response && err.response.status);
  }
}

export const logoutUserHandler = (callBackFunc) => {

  const sessionToken = localStorage.getItem("GuestJourneySessionToken");
  return async dispatch => {
    if (sessionToken) {
      clientConfigApi.post(
        "/guestDevice/delink",
        {
          "header": {
            "sessionToken": sessionToken

          }
        }
      ).then(({ status }) => {
        console.log("logout api response", status)
        if (status === 200) {
          callBackFunc(true)
          wipeGuestData({ inRoomTab: process.env.REACT_APP_INROOMTAB == "true" })
        }
      }
      ).catch(({ response = {} }) => {
        console.log("logout api faild", response.status);
        callBackFunc(false, "Failed to get the data");
        if (response.data && response.data.header && response.data.header.status.msg.toLowerCase().includes("device not found")) {
          if (response.status == 401) {
            wipeGuestData({ inRoomTab: process.env.REACT_APP_INROOMTAB == "true" })
          } else {
            localStorage.removeItem("GuestJourneySessionToken")
            window.location.reload()
          }
          if (window.FirebasePlugin) {
            window.FirebasePlugin.logError("delink Api failed with the status code:" + response.data.header.status.msg)
          }
        }
        if (response.status == 401) {
          wipeGuestData({ inRoomTab: process.env.REACT_APP_INROOMTAB == "true" })
        }
      })
    }
  }
}

export const getGuestStepsDropdownOptions = (token) => {
  return async dispatch => {
    let room = localStorage.getItem("room")
    room = room && room !== "null" ? room : "notLogin"
    try {
      clientConfigApi.post(
        "/core/configsFetch" + `?dId=${localStorage.getItem('deviceIdentifierFromCMS')}&rn=${room}`, {
        "header": {
          "sessionToken": token
        },
        "payload": {
          "actionKey": "guestStepsDropdownData"
        }

      }
      )
        .then(res => {
          console.log("guest steps dropdown options", res)
          if (res.data && res.data.payload && res.data.payload.guestStepsData) {
            dispatch({
              type: "Set_guest_steps_dropdown_options",
              payload: res.data.payload.guestStepsData
            })
          } else {
            dispatch({
              type: "Set_guest_steps_dropdown_options",
              payload: []
            })
          }
          if (window.FirebasePlugin) {
            window.FirebasePlugin.logEvent("guest_steps_api_response", { status: "success" });
          }
        })
        .catch(({ response = {} }) => {
          console.log("Api failed with the status code:", response.status)
          if (response.data && response.data.header && response.data.header.status.msg.toLowerCase().includes("device not found")) {
            localStorage.removeItem("GuestJourneySessionToken")
            window.location.reload()
            if (window.FirebasePlugin) {
              window.FirebasePlugin.logError("guestStepsDropdownData Api failed with the status code:" + response.data.header.status.msg)
              window.FirebasePlugin.logEvent("guest_steps_api_response", { status: "failed", error: response.data.header.status.msg });
            }
          }
        })
    } catch (e) {
      console.log("error in guest steps dropdown options api", e);
      if (window.FirebasePlugin) {
        window.FirebasePlugin.logError("guestStepsDropdownData Api failed with the status code:" + e.message)
        window.FirebasePlugin.logEvent("guest_steps_api_response", { status: "failed", error: e.message });
      }
    }
  }
}

export const getGuestDocListData = (token) => {
  return async dispatch => {
    let room = localStorage.getItem("room")
    room = room && room !== "null" ? room : "notLogin"
    try {
      clientConfigApi.post(
        "/core/configsFetch" + `?dId=${localStorage.getItem('deviceIdentifierFromCMS')}&rn=${room}`, {
        "header": {
          "sessionToken": token
        },
        "payload": {
          "actionKey": "guestDocListData"
        }

      }
      )
        .then(res => {
          if (res.data && res.data.payload && res.data.payload.guestAllowedDocumentListData) {
            dispatch({
              type: "Set_guest_doc_options",
              payload: res.data.payload.guestAllowedDocumentListData
            })
          } else {
            dispatch({
              type: "Set_guest_doc_options",
              payload: []
            })
          }
        })
        .catch(({ response = {} }) => {
          console.log("Api failed with the status code:", response.status)
        })
    } catch (e) {
      console.log("error in guest steps dropdown options api", e);
    }
  }
}

export const getLatestAppVersion = (token, applicationId, osType, osVersion, callBack, callFromPause) => {
  console.log(' getLatestAppVersion ', token, applicationId, osType, osVersion)
  let room = localStorage.getItem("room")
  room = room && room !== "null" ? room : "notLogin"
  let current_hotel_code = (localStorage.getItem("clientId") || sessionStorage.getItem("clientId") || process.env.REACT_APP_CLIENT_CONFIG || "").replace("GJ_", "").toUpperCase();
  return async dispatch => {
    try {
      clientConfigApi.post(
        "/core/configsFetch" + `?dId=${localStorage.getItem('deviceIdentifierFromCMS')}&rn=${room}`, {
        "header": {
          "sessionToken": token
        },
        "payload": {
          "actionKey": "guestJourneyConfigData",
          "applicationID": applicationId, //applicationId
          "osType": osType, //android/ios
          "osVersion": osVersion
        }

      }
      )
        .then(res => {
          console.log("App Version for Force update", res)
          if (res.data && res.data.payload) {// && osType === 'iOS'
            localStorage.setItem(`layoutCssData_${current_hotel_code}`,JSON.stringify(res.data.payload.layoutCssData))
            dispatch({
              type: "Set_Latest_App_Data",
              payload: res.data.payload
            })

            dispatch({
              type: "Set_Layout_CSS_Data",
              payload: res.data.payload.layoutCssData
            })
            dispatch({
              type: "Show_Bookmark_Popup",
              payload: res.data.payload.bookmarkPopup || false
            })
            dispatch({
              type: "Enable_Checkout_Only_At_Last_Day",
              payload: res.data.payload.checkOutOnlyOnLastDay || false
            })
            dispatch({
              type: 'Set_FreshChat_Data',
              payload: res.data.payload.chatInterface
            })

            console.log('callback called from app info')
            callBack();
            if (callFromPause) {
              callFromPause();
            }
          }
        })
        .catch(({ response = {} }) => {
          console.log("Api failed with the status code:", response.status)
          if (window.FirebasePlugin) {
            // window.FirebasePlugin.logMessage("deviceConfig API failed using faceBasedJson() face data = " + faceData + "response = " + response);
            window.FirebasePlugin.logError("Force update Api failed with the status code: " + response.status, osType)
          }
          const cachedLayoutCssData = localStorage.getItem(`layoutCssData_${current_hotel_code}`)
          if (cachedLayoutCssData) {
            dispatch({
              type: "Set_Layout_CSS_Data",
              payload: JSON.parse(cachedLayoutCssData)
            })
          }
        })
    } catch (e) {
      console.log("error in force update version api", e, osType);
      if (window.FirebasePlugin) {
        // window.FirebasePlugin.logMessage("deviceConfig API failed using faceBasedJson() face data = " + faceData + "response = " + response);
        window.FirebasePlugin.logError("Force update Api failed with the status code: " + e, osType)
      }
    }
  }
}

//---------------------------guest journey notification----------------------

export const guestJourneyNotification = (token) => {

  return async dispatch => {
    let room = localStorage.getItem("room")
    room = room && room !== "null" ? room : "notLogin"
    try {
      clientConfigApi.put(
        "/textMessage/fetch" + `?dId=${localStorage.getItem('deviceIdentifierFromCMS')}&rn=${room}`,
        {
          "header": {
            "sessionToken": token,
            "requester": "webApp"
          }

        }
      ).then((res) => {
        console.log("res notifications", res);
        if (res && res.data && res.data.payload && res.data.payload.messages) {
          //console.log("isGuestCheckedIn", res.data.payload.isGuestCheckedIn);
          dispatch({
            type: 'Set_GJ_Notifications',
            payload: res.data.payload.messages
          })
        } else {
          dispatch({
            type: 'Set_GJ_Notifications',
            payload: []
          })
        }
      })
        .catch(
          ({ response = {} }) => {
            if (response.status == 401) {
              wipeGuestData({ inRoomTab: process.env.REACT_APP_INROOMTAB == "true" })
            }
            console.log("Notification Api failed with the status code:", response.status);
          }
        )
    } catch (e) {
      console.log(`error in api call to path= "/textMessage/fetch"`, e);
    }
  }
}



// Analytics

export const sendAnalytics = (guestDetail, category, actionType, label, value, sendAppendDemoGraphics, callback) => {

  console.log("send analytics called", actionType, JSON.stringify(label))
  let deviceIdentifier = localStorage.getItem('deviceIdentifierFromCMS')
  let token = localStorage.getItem("GuestJourneySessionToken")
  let room = localStorage.getItem("room");

  return async dispatch => {
    if (process.env.REACT_APP_SEND_ANALYTICS == 'false' || !token || token == "null") return;

    if (!category || category == "") {
      console.log("Cannot send GA event as category is not provided")
      return;
    }

    let InfoLabel = {
      ...label,
      "deviceIdentifierFromCMS": deviceIdentifier,
      "platform": window.device ? window.device.platform : "Web",
      "phoneVersion": window && window.device && window.device.version ? window.device.version : "",
      "phoneModel": window && window.device && window.device.model ? window.device.model : "",
      "phoneManufacturer": window && window.device && window.device.manufacturer ? window.device.manufacturer : ""
    };


    if (localStorage.getItem("checkinSessionBookingNumber")) {
      InfoLabel = {
        ...InfoLabel,
        "bookingNumber": localStorage.getItem("checkinSessionBookingNumber"),
      }
    } 

    if (localStorage.getItem("theKnowUserInfo")) {
      try {
        const userInfo = JSON.parse(localStorage.getItem("theKnowUserInfo"));
        if (userInfo.memberId) {
          InfoLabel = {
            ...InfoLabel,
            memberId: userInfo.memberId,
          };
        }
      } catch (e) {
        console.error("Error parsing theKnowUserInfo:", e);
      }
    }

    //updating time spent on widget
    if (InfoLabel.duration) {
      let timeSpentOnWidget = +InfoLabel.duration * 1000
      InfoLabel = { ...InfoLabel, value: timeSpentOnWidget }
    }

    // adding BirthDate and Nationality from Id card scan.
    let extra_guest_data = localStorage.getItem("extra_guest_details") ? JSON.parse(localStorage.getItem("extra_guest_details")) : null
    if (extra_guest_data) {
      InfoLabel = { ...InfoLabel, birthDate: extra_guest_data.birthDate || "", nationality: extra_guest_data.nationality }
    }


    let current_logged_in_guest = JSON.parse(localStorage.getItem("Set_Current_Logged_In_Guest_Details")) || null
    if (room && room != "null" && current_logged_in_guest) {
      //updating Birthdate
      if (current_logged_in_guest[0].guestProfile && current_logged_in_guest[0].guestProfile.birthday != "") {
        InfoLabel = { ...InfoLabel, birthDate: current_logged_in_guest[0].guestProfile.birthday || "" }
      }
    }

    // return true
    try {
      clientConfigApi.post(
        "/deviceAnalytics/send", {
        "header": {
          // "guestToken": guestToken,
          // "locationId": locationId,
          "sessionToken": token,
          "dataSource": "guestJourney"
        },
        "payload": {
          "data": [{
            "category": category.trim().replace(/ /g, "_").replace(/-/g, "_"),
            "action": actionType,
            "label": InfoLabel, //, ...{appVersion: '0.1(1)'}
            "value": value,
            "appendDemographics": sendAppendDemoGraphics
          }]
        }
      })
        .then(res => {
          console.log("success", res);
          callback && callback(true);
        })
        .catch(({ response = {} }) => {
          console.log("Api failed with the status code:", response.status);
          // if(window.FirebasePlugin){
          //   window.FirebasePlugin.logMessage("error messege =>  for widget: " + category 
          //                                                       + ", action: " + actionType 
          //                                                       + ", label: " + JSON.stringify(label)
          //                                                       + ", value: " + value);
          //   window.FirebasePlugin.logError("GA api failed")
          // }
          callback && callback(false);
        })
    } catch (e) {
      console.log("error in GA api call", e);
      // if(window.FirebasePlugin){
      //     window.FirebasePlugin.logMessage("error messege =>  for widget: " + category 
      //                                                         + ", action: " + actionType 
      //                                                         + ", label: " + JSON.stringify(label)
      //                                                         + ", value: " + value);
      //     window.FirebasePlugin.logError("GA api failed")
      //   }
      callback && callback(false);
    }
  }
}

export const getGalleryImages = (galleryId, callback) => {
  return async dispatch => {
    try {
      clientConfigApi.post(
        "/galleryApp/get",
        {
          "header": {
            "galleryId": galleryId
          },
          "payload": {}
        }
      ).then(res => {
        dispatch({
          type: "Gallery_App_Data",
          payload: res.data.payload
        })
        callback(true)
      }).catch(err => {
        console.log(err);
        callback(false)
      })
    } catch (error) {
      callback(false)
    }
  }
}

export const setGalleryAppData = (data) => {
  return {
    type: "Gallery_App_Data",
    payload: data
  }
}

export const setDoorKeyGuide = (bool) => {
  return {
    type: "Set_Door_Key_Guide",
    payload: bool
  }
}

export const setWarningPopup = obj => {
  return {
    type: "Set_Warning_Popup",
    payload: obj
  }
}